import { TEXT_FONTS } from '@tokamap/core';

export const POSITIONS = [0, 0.5, 1];

export const POSITION_LABELS = [
	['En haut à gauche', 'En haut', 'En haut à droite'],
	['À gauche', 'Au centre', 'À droite'],
	['En bas à gauche', 'En bas', 'En bas à droite'],
];

export function positionLabel(horizontal?: number, vertical?: number): string | undefined {
	if (horizontal === undefined || vertical === undefined) return undefined;

	const row = POSITIONS.indexOf(vertical);
	const column = POSITIONS.indexOf(horizontal);

	return row >= 0 && column >= 0 ? POSITION_LABELS[row]![column]! : 'Position libre';
}

export function fontLabel(font: string | undefined): string {
	return TEXT_FONTS.find(candidate => candidate.id === font)?.label ?? 'Noto Sans';
}
